module.exports = __webpack_public_path__ + "img/mobile/BetBar/btn-sound_on@1x.png?0.0.53";